module.exports = __webpack_public_path__ + "statics/img/PainPoints-2@2x.e9552e6d.png";